import { Action } from '@ngrx/store';
import {UpdateInfoModel} from '../update-info.model';

export enum UpdateInfoActionTypes {
  UPDATE_INFO = '[UpdateInfo] UPDATE_INFO',
  UPDATE_INFO_SUCCESS = '[UpdateInfo] UPDATE_INFO_SUCCESS',
  UPDATE_INFO_FAIL = '[UpdateInfo] UPDATE_INFO_FAIL'
}

export class UpdateInfoAction implements Action {
  readonly type = UpdateInfoActionTypes.UPDATE_INFO;
  constructor(public payload: UpdateInfoModel = null) {}
}

export class UpdateInfoSuccessAction implements Action {
  readonly type = UpdateInfoActionTypes.UPDATE_INFO_SUCCESS;
  constructor(public payload: UpdateInfoModel = null) {}
}

export class UpdateInfoFailAction implements Action {
  readonly type = UpdateInfoActionTypes.UPDATE_INFO_FAIL;
  constructor(public payload: UpdateInfoModel = null) {}
}


export type UpdateInfoActions = UpdateInfoSuccessAction
  | UpdateInfoFailAction
  | UpdateInfoAction;
